import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { isEmpty, get } from 'lodash';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import { MISSING_SUBSCRIPTION, NOT_AUTHENTICATED } from 'constants/visibility-types';
import { CONTENT_TYPES } from 'constants/content-types';
import useModals from 'hooks/useModals';

export default () => {
  const history = useHistory();
  const { showLoginModal } = useModals();

  const onEnter = useCallback(
    (item, focusBackConfig, analyticsParams) => {
      let itemId = item.targetId || item.id;
      let itemType = item.type || get(item.metadata, ['contentType']);

      const search = item.sourceCarouselId ? `sourceCarouselId=${item.sourceCarouselId}` : '';

      if (get(item.metadata, ['tvSeriesId']) && itemType === CONTENT_TYPES.VOD_ASSET) {
        itemId = item.metadata.tvSeriesId;
        itemType = CONTENT_TYPES.TV_SERIES;
      }

      if (analyticsParams) {
        const addInfo = `vod_asset_id=${itemId};channel_id=null;content_type=MOVIE;type=${itemType};epgEventState=null`;
        innerAnalyticsVolia.postEvent({ ...analyticsParams, addInfo });
      }

      // If it's a channel we suggest to sign in and buy subscription
      if (!isEmpty(item.epgEventUrl)) {
        if (item.visibilityDetails === NOT_AUTHENTICATED) return showLoginModal(focusBackConfig);
        if (item.visibilityDetails === MISSING_SUBSCRIPTION) {
          const onSuccess = `/details/${itemType}/${itemId}?${search}`;
          return history.push({
            pathname: '/profile/packages/filter',
            search: `?channelId=${itemId}&onSuccess=${onSuccess}`,
          });
        }
      }

      history.push({ pathname: `/details/${itemType}/${itemId}`, search });
    },
    [history, showLoginModal],
  );

  return onEnter;
};
